<div class="loader-container" [style.width]="width()" [style.height]="height()">
    <div class="blob">
    </div>
</div>
